import type { PropsWithChildren } from 'react';

import type { BoxProps } from '@mui/material';

import { InternalDashboardLayout } from '@ll-platform/frontend/components/InternalDashboard/components/layout/InternalDashboardLayout';
import { DashboardLayoutContentWrapper } from '@ll-platform/frontend/components/layouts/DashboardLayout/DashboardLayoutContentWrapper';
import { NavigationBar } from '@ll-platform/frontend/components/NavigationBar';
import { useActiveUser } from '@ll-platform/frontend/core/auth/hooks/useActiveUser';
import { isUserInternal } from '@ll-platform/frontend/core/auth/utils/isInternal';

export const ExternalDashboardLayout = ({ children, ...props }: BoxProps) => {
  return (
    <>
      <NavigationBar />
      <DashboardLayoutContentWrapper {...props}>
        {children}
      </DashboardLayoutContentWrapper>
    </>
  );
};

// Use this component for pages accessible by both external and internal users (like settings)
export const DashboardLayout = ({ children }: PropsWithChildren) => {
  const { activeUser } = useActiveUser();

  if (isUserInternal(activeUser)) {
    return <InternalDashboardLayout>{children}</InternalDashboardLayout>;
  }

  return (
    <ExternalDashboardLayout sx={{ py: 2 }}>{children}</ExternalDashboardLayout>
  );
};
